// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/******************************
*  colors tokens
******************************/
:root {
  --m-primary: #0C8479;
  --m-primary-bolder: #0A726A;
  --m-primary-xbolder: #086058;
  --m-secondary: #1f201e;
  --m-success: #039e68;
  --m-success-bolder: #03895a;
  --m-success-xbolder: #02724b;
  --m-neutral: #42516d;
  --m-neutral-bolder: #38455d;
  --m-neutral-xbolder: #2e394d;
  --m-warning: #f5cd47;
  --m-warning-bolder: #f3c11c;
  --m-warning-xbolder: #d7a70b;
  --m-danger: #ca371c;
  --m-danger-bolder: #ad2e18;
  --m-danger-xbolder: #902614;
  --m-subtle: #EBEBEF;
  --m-subtle-bolder: #DEE0E5;
  --m-subtle-xbolder: #C0C6CF;
  --m-subtle-xxbolder: #5D6B83;
  --m-subtle-xxxbolder: #4F5E78;
  --m-subtle-light: #F3F4F6;
  --m-background-color: #f6f7fb;
  --m-card-background-color: #fff;
  --m-subtle-card-background-color: #f4f6fa;
  --m-sidebar-background-color: #fff;
  --m-tooltip-background-color: #fff;
  --m-header-background-color: #fff;
  --m-email-background-color: #fff;
  --m-chat-background-color: #fff;
  --m-modal-overlay-background-color: #23304347;
  --m-scrollbar-color: #fff;
  --m-scrollbar-color-hovered: #d1d6db;
  --m-dropdown-hover: #f6f7fb;
  --m-background-primary: #0C8479;
  --m-background-primary-hovered: #0A726A;
  --m-background-primary-pressed: #086058;
  --m-background-subtle-primary: #E6F3F2;
  --m-background-subtle-primary-hovered: #D1E9E7;
  --m-background-subtle-primary-pressed: #BCDFDC;
  --m-background-secondary: #1f201e;
  --m-background-secondary-hovered: #1c1d1c;
  --m-background-secondary-pressed: #1a1b19;
  --m-background-subtle-secondary: #efefee;
  --m-background-subtle-secondary-hovered: #dfe0de;
  --m-background-subtle-secondary-pressed: #cfd0cd;
  --m-background-success: #039e68;
  --m-background-success-hovered: #039562;
  --m-background-success-pressed: #03895a;
  --m-background-subtle-success: #ecfaf2;
  --m-background-subtle-success-hovered: #cefeed;
  --m-background-subtle-success-pressed: #b6fee5;
  --m-background-neutral: #42516d;
  --m-background-neutral-hovered: #3c4a65;
  --m-background-neutral-pressed: #38455d;
  --m-background-subtle-neutral: #f0f2f6;
  --m-background-subtle-neutral-hovered: #e1e5ed;
  --m-background-subtle-neutral-pressed: #d2d8e4;
  --m-background-warning: #f5cd47;
  --m-background-warning-hovered: #f4c731;
  --m-background-warning-pressed: #f3c11c;
  --m-background-subtle-warning: #fff6e6;
  --m-background-subtle-warning-hovered: #fef8e5;
  --m-background-subtle-warning-pressed: #fdf4d8;
  --m-background-danger: #ca371c;
  --m-background-danger-hovered: #bc321a;
  --m-background-danger-pressed: #ad2e18;
  --m-background-subtle-danger: #ffefef;
  --m-background-subtle-danger-hovered: #fae0dc;
  --m-background-subtle-danger-pressed: #f8d1ca;
  --m-border: #D0D5DD;
  --m-border-primary: #0C8479;
  --m-border-secondary: #1f201e;
  --m-border-success: #039e68;
  --m-border-neutral: #42516d;
  --m-border-warning: #f5cd47;
  --m-border-danger: #ca371c;
  --m-border-tooltip: #fff;
  --m-border-card-file: #EBEBEF;
  --m-default-border: 1.5px solid #D0D5DD;
  --m-border-color: #EBEBEF;
  --m-border-dropdown: #EBEBEF;
  --m-icon-color: #66718F;
  --m-icon-primary: #0C8479;
  --m-icon-secondary: #1f201e;
  --m-icon-success: #039e68;
  --m-icon-neutral: #42516d;
  --m-icon-warning: #f5cd47;
  --m-icon-danger: #ca371c;
  --m-white: #fff;
  --m-text: #162949;
  --m-text-light: #74788b;
  --m-text-muted: #6A768B;
  --m-text-primary: #0C8479;
  --m-text-secondary: #1f201e;
  --m-text-success: #039e68;
  --m-text-neutral: #42516d;
  --m-text-warning: #f5cd47;
  --m-text-danger: #ca371c;
  --m-nav-item: #5a697d;
}

[m-data-theme=dark] {
  --m-background-color: #222735;
  --m-card-background-color: #293042;
  --m-subtle-card-background-color: #47506b66;
  --m-sidebar-background-color: #293042;
  --m-header-background-color: #222735;
  --m-tooltip-background-color: #293042;
  --m-email-background-color: #222735;
  --m-chat-background-color: #222735;
  --m-modal-overlay-background-color: #00000033;
  --m-dropdown-hover: #3e4555;
  --m-scrollbar-color: transparent;
  --m-scrollbar-color-hovered: #ffffff26;
  --m-text: #cfcde4;
  --m-text-light: #A8A5CF;
  --m-text-muted: #949DAD;
  --m-border: #5D6B83;
  --m-border-tooltip: #ffffff4D;
  --m-border-card-file: transparent;
  --m-default-border: 1.5px solid #5D6B83;
  --m-border-color: #5D6B83;
  --m-border-dropdown: #5D6B83;
  --m-primary: #0C8479;
  --m-primary-bolder: #0A726A;
  --m-primary-xbolder: #086058;
  --m-secondary: #d1d1cf;
  --m-success: #21c589;
  --m-success-bolder: #1aa374;
  --m-success-xbolder: #13815e;
  --m-neutral: #7183a1;
  --m-neutral-bolder: #606f8d;
  --m-neutral-xbolder: #4f5e79;
  --m-warning: #F6CE4C;
  --m-warning-bolder: #F3C220;
  --m-warning-xbolder: #DAAA0B;
  --m-danger: #F66C77;
  --m-danger-bolder: #F23B4A;
  --m-danger-xbolder: #EC0F22;
  --m-subtle-light: #47506b66;
  --m-background-primary: #0C8479;
  --m-background-primary-hovered: #0A726A;
  --m-background-primary-pressed: #086058;
  --m-background-warning: #F6CE4C;
  --m-background-warning-hovered: #F3C220;
  --m-background-warning-pressed: #DAAA0B;
  --m-background-danger: #F66C77;
  --m-background-danger-hovered: #F23B4A;
  --m-background-danger-pressed: #EC0F22;
  --m-background-subtle-primary: #313e51;
  --m-background-subtle-success: #464e4b;
  --m-background-subtle-warning: #494846;
  --m-background-subtle-danger: #514341b3;
  --m-background-subtle-neutral: #384152;
}

[m-data-top-menu-theme=dark] {
  --m-header-background-color: #222735;
}`, "",{"version":3,"sources":["webpack://./src/styles/tokens/_colors.scss"],"names":[],"mappings":"AAAA;;8BAAA;AAGA;EACI,oBAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,oBAAA;EACA,2BAAA;EACA,4BAAA;EACA,oBAAA;EACA,2BAAA;EACA,4BAAA;EACA,oBAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,0BAAA;EACA,2BAAA;EACA,mBAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;EAEA,6BAAA;EACA,+BAAA;EACA,yCAAA;EACA,kCAAA;EACA,kCAAA;EACA,iCAAA;EACA,gCAAA;EACA,+BAAA;EACA,6CAAA;EAEA,yBAAA;EACA,oCAAA;EAEA,2BAAA;EAEA,+BAAA;EACA,uCAAA;EACA,uCAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EAEA,iCAAA;EACA,yCAAA;EACA,yCAAA;EACA,wCAAA;EACA,gDAAA;EACA,gDAAA;EAEA,+BAAA;EACA,uCAAA;EACA,uCAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EAEA,+BAAA;EACA,uCAAA;EACA,uCAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EAEA,+BAAA;EACA,uCAAA;EACA,uCAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EAEA,8BAAA;EACA,sCAAA;EACA,sCAAA;EACA,qCAAA;EACA,6CAAA;EACA,6CAAA;EAEA,mBAAA;EACA,2BAAA;EACA,6BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,0BAAA;EACA,wBAAA;EACA,6BAAA;EACA,uCAAA;EACA,yBAAA;EACA,4BAAA;EAEA,uBAAA;EACA,yBAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,wBAAA;EAEA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,wBAAA;EAEA,qBAAA;AAZJ;;AAeA;EACI,6BAAA;EACA,kCAAA;EACA,2CAAA;EACA,qCAAA;EACA,oCAAA;EACA,qCAAA;EACA,mCAAA;EACA,kCAAA;EACA,6CAAA;EAEA,2BAAA;EAEA,gCAAA;EACA,sCAAA;EAEA,iBAAA;EACA,uBAAA;EACA,uBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,iCAAA;EACA,uCAAA;EACA,yBAAA;EACA,4BAAA;EAEA,oBAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,oBAAA;EACA,2BAAA;EACA,4BAAA;EACA,oBAAA;EACA,2BAAA;EACA,4BAAA;EACA,oBAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EAEA,+BAAA;EACA,uCAAA;EACA,uCAAA;EACA,+BAAA;EACA,uCAAA;EACA,uCAAA;EACA,8BAAA;EACA,sCAAA;EACA,sCAAA;EAEA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,uCAAA;EACA,sCAAA;AAnBJ;;AAsBA;EACI,oCAAA;AAnBJ","sourcesContent":["/******************************\n*  colors tokens\n******************************/\n:root {\n    --m-primary: #0C8479;\n    --m-primary-bolder: #0A726A;\n    --m-primary-xbolder: #086058;\n    --m-secondary: #1f201e;\n    --m-success: #039e68;\n    --m-success-bolder: #03895a;\n    --m-success-xbolder: #02724b;\n    --m-neutral: #42516d;\n    --m-neutral-bolder: #38455d;\n    --m-neutral-xbolder: #2e394d;\n    --m-warning: #f5cd47;\n    --m-warning-bolder: #f3c11c;\n    --m-warning-xbolder: #d7a70b;\n    --m-danger: #ca371c;\n    --m-danger-bolder: #ad2e18;\n    --m-danger-xbolder: #902614;\n    --m-subtle: #EBEBEF;\n    --m-subtle-bolder: #DEE0E5;\n    --m-subtle-xbolder: #C0C6CF;\n    --m-subtle-xxbolder: #5D6B83;\n    --m-subtle-xxxbolder: #4F5E78;\n    --m-subtle-light: #F3F4F6;\n\n    --m-background-color: #f6f7fb;\n    --m-card-background-color: #fff;\n    --m-subtle-card-background-color: #f4f6fa;\n    --m-sidebar-background-color: #fff;\n    --m-tooltip-background-color: #fff;\n    --m-header-background-color: #fff;\n    --m-email-background-color: #fff;\n    --m-chat-background-color: #fff;\n    --m-modal-overlay-background-color: #23304347;\n\n    --m-scrollbar-color: #fff;\n    --m-scrollbar-color-hovered: #d1d6db;\n\n    --m-dropdown-hover: #f6f7fb;\n\n    --m-background-primary: #0C8479;\n    --m-background-primary-hovered: #0A726A;\n    --m-background-primary-pressed: #086058;\n    --m-background-subtle-primary: #E6F3F2;\n    --m-background-subtle-primary-hovered: #D1E9E7;\n    --m-background-subtle-primary-pressed: #BCDFDC;\n\n    --m-background-secondary: #1f201e;\n    --m-background-secondary-hovered: #1c1d1c;\n    --m-background-secondary-pressed: #1a1b19;\n    --m-background-subtle-secondary: #efefee;\n    --m-background-subtle-secondary-hovered: #dfe0de;\n    --m-background-subtle-secondary-pressed: #cfd0cd;\n\n    --m-background-success: #039e68;\n    --m-background-success-hovered: #039562;\n    --m-background-success-pressed: #03895a;\n    --m-background-subtle-success: #ecfaf2;\n    --m-background-subtle-success-hovered: #cefeed;\n    --m-background-subtle-success-pressed: #b6fee5;\n\n    --m-background-neutral: #42516d;\n    --m-background-neutral-hovered: #3c4a65;\n    --m-background-neutral-pressed: #38455d;\n    --m-background-subtle-neutral: #f0f2f6;\n    --m-background-subtle-neutral-hovered: #e1e5ed;\n    --m-background-subtle-neutral-pressed: #d2d8e4;\n\n    --m-background-warning: #f5cd47;\n    --m-background-warning-hovered: #f4c731;\n    --m-background-warning-pressed: #f3c11c;\n    --m-background-subtle-warning: #fff6e6;\n    --m-background-subtle-warning-hovered: #fef8e5;\n    --m-background-subtle-warning-pressed: #fdf4d8;\n\n    --m-background-danger: #ca371c;\n    --m-background-danger-hovered: #bc321a;\n    --m-background-danger-pressed: #ad2e18;\n    --m-background-subtle-danger: #ffefef;\n    --m-background-subtle-danger-hovered: #fae0dc;\n    --m-background-subtle-danger-pressed: #f8d1ca;\n\n    --m-border: #D0D5DD;\n    --m-border-primary: #0C8479;\n    --m-border-secondary: #1f201e;\n    --m-border-success: #039e68;\n    --m-border-neutral: #42516d;\n    --m-border-warning: #f5cd47;\n    --m-border-danger: #ca371c;\n    --m-border-tooltip: #fff;\n    --m-border-card-file: #EBEBEF;\n    --m-default-border: 1.5px solid #D0D5DD;\n    --m-border-color: #EBEBEF;\n    --m-border-dropdown: #EBEBEF;\n    \n    --m-icon-color: #66718F;\n    --m-icon-primary: #0C8479;\n    --m-icon-secondary: #1f201e;\n    --m-icon-success: #039e68;\n    --m-icon-neutral: #42516d;\n    --m-icon-warning: #f5cd47;\n    --m-icon-danger: #ca371c;\n\n    --m-white: #fff;\n    --m-text: #162949;\n    --m-text-light: #74788b;\n    --m-text-muted: #6A768B;\n    --m-text-primary: #0C8479;\n    --m-text-secondary: #1f201e;\n    --m-text-success: #039e68;\n    --m-text-neutral: #42516d;\n    --m-text-warning: #f5cd47;\n    --m-text-danger: #ca371c;\n\n    --m-nav-item: #5a697d;\n}\n\n[m-data-theme='dark'] {\n    --m-background-color: #222735;\n    --m-card-background-color: #293042;\n    --m-subtle-card-background-color: #47506b66;\n    --m-sidebar-background-color: #293042;\n    --m-header-background-color: #222735;\n    --m-tooltip-background-color: #293042;\n    --m-email-background-color: #222735;\n    --m-chat-background-color: #222735;\n    --m-modal-overlay-background-color: #00000033;\n    \n    --m-dropdown-hover: #3e4555;\n\n    --m-scrollbar-color: transparent;\n    --m-scrollbar-color-hovered: #ffffff26;\n\n    --m-text: #cfcde4;\n    --m-text-light: #A8A5CF;\n    --m-text-muted: #949DAD;\n\n    --m-border: #5D6B83;\n    --m-border-tooltip: #ffffff4D;\n    --m-border-card-file: transparent;\n    --m-default-border: 1.5px solid #5D6B83;\n    --m-border-color: #5D6B83;\n    --m-border-dropdown: #5D6B83;\n\n    --m-primary: #0C8479; \n    --m-primary-bolder: #0A726A; \n    --m-primary-xbolder: #086058;\n    --m-secondary: #d1d1cf;\n    --m-success: #21c589;\n    --m-success-bolder: #1aa374;\n    --m-success-xbolder: #13815e;\n    --m-neutral: #7183a1;\n    --m-neutral-bolder: #606f8d;\n    --m-neutral-xbolder: #4f5e79;\n    --m-warning: #F6CE4C;\n    --m-warning-bolder: #F3C220;\n    --m-warning-xbolder: #DAAA0B;\n    --m-danger: #F66C77;\n    --m-danger-bolder: #F23B4A;\n    --m-danger-xbolder: #EC0F22;\n    --m-subtle-light: #47506b66;\n\n    --m-background-primary: #0C8479;\n    --m-background-primary-hovered: #0A726A;\n    --m-background-primary-pressed: #086058;\n    --m-background-warning: #F6CE4C;\n    --m-background-warning-hovered: #F3C220;\n    --m-background-warning-pressed: #DAAA0B;\n    --m-background-danger: #F66C77;\n    --m-background-danger-hovered: #F23B4A;\n    --m-background-danger-pressed: #EC0F22;\n\n    --m-background-subtle-primary: #313e51;\n    --m-background-subtle-success: #464e4b;\n    --m-background-subtle-warning: #494846;\n    --m-background-subtle-danger: #514341b3;\n    --m-background-subtle-neutral: #384152;\n}\n\n[m-data-top-menu-theme=\"dark\"] {\n    --m-header-background-color: #222735;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
